export const AplPeriodGroup = {
  ONGOING: "InProgress",
  UPCOMING: "Coming",
  ENDED: "Ended",
};
